import React from "react";
import styled from "styled-components";
import { IoLogoJavascript } from "react-icons/io";
import { FaFigma, FaNodeJs, FaReact } from "react-icons/fa";
import { TiCss3 } from "react-icons/ti";
import { TbBrandHtml5 } from "react-icons/tb";
import { AiFillLinkedin } from "react-icons/ai";

const IconLinearG =
  "linear-gradient(180deg, rgba(105, 59, 147, 0.53) 0%, #693B93 100%)";
const MainUniverContainer = styled.div`
  width: 100%;
  min-height: 500px;
  position: relative;
  @media (max-width: 770px) {
    min-height: 300px;
  }
`;
const Ellipse = styled.div`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  border-radius: 60%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  border-bottom: 1px solid #693b93;
  border-left: 1px solid #693b93;
  border-right: 1px solid #693b93;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Earth = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 4rem;
  color: #fff;
  text-shadow: 2px 2px 5px #fff, -2px -2px 5px #fff;
  height: 180px;
  width: 180px;
  background: linear-gradient(
    180deg,
    rgba(48, 16, 128, 0.6) 0%,
    rgba(120, 64, 173, 0.36) 100%
  );
  /* background-image: url("./assets/earth.png"); */
  background-size: contain;
  background-position: center;
  border-radius: 50%;
  border-top: 1px solid #693b93;
  @media (max-width: 770px) {
    width: 84px;
    height: 84px;
    font-size: 2rem;
  }
`;
const MidImage = styled.span`
  display: inline-block;
  height: 330px;
  width: 542px;
  background: radial-gradient(
    50% 50% at 50% 50%,
    #763cac 0%,
    rgba(50, 15, 133, 0) 100%
  );
  @media (max-width: 770px) {
    height: 200px;
    width: 100%;
  }
`;
const Universe = () => {
  return (
    <MainUniverContainer data-aos="zoom-in">
      <Ellipse width={"100%"} height={"40%"}>
        <AiFillLinkedin
          size={24}
          style={{
            left: "0px",
            position: "absolute",
            color: "#693B93",
          }}
        />
        <FaReact
          size={24}
          style={{
            right: "0px",
            position: "absolute",
            color: "#693B93",
          }}
        />
        <IoLogoJavascript
          size={24}
          style={{
            left: "16%",
            bottom: "5%",
            position: "absolute",
            background: IconLinearG,
          }}
        />
      </Ellipse>
      <Ellipse width={"80%"} height={"40%"}>
        <TiCss3
          size={24}
          style={{
            right: "9%",
            top: "12%",
            position: "absolute",
            background: IconLinearG,
          }}
        />
        <FaNodeJs
          size={24}
          style={{
            left: "20%",
            top: "5%",
            position: "absolute",

            background: IconLinearG,
          }}
        />
        <MidImage />
      </Ellipse>
      <Ellipse width={"60%"} height={"40%"}>
        <TbBrandHtml5
          size={34}
          style={{
            left: "40%",
            bottom: "-9%",
            position: "absolute",
            background: IconLinearG,
          }}
        />
        <FaFigma
          size={24}
          style={{
            right: "0%",
            top: "58%",
            position: "absolute",
            color: "#693B93",
          }}
        />
        <Earth>
          Er. <span>spirit</span>
        </Earth>
      </Ellipse>
    </MainUniverContainer>
  );
};

export default Universe;
